/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */

import "./style.css";
import { useState } from "react";
import React from "react";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Rating from '@mui/material/Rating';
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import {
  Button,
 
} from "@mui/material";
import { ThemeProvider,createTheme } from "@mui/material";
import { useInView } from "framer-motion";
import { useRef } from "react";
import Avatar from '@mui/material/Avatar';
import { deepOrange } from '@mui/material/colors';
import Footer from '../../Components/Footer'
import face2 from "../../Images/icons/face2.png";
import whats2 from "../../Images/icons/whats2.png";
import insta2 from "../../Images/icons/insta2.png";
import tik2 from "../../Images/icons/tik2.png";
import snap2 from "../../Images/icons/snap2.png";
const customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,  
        sm: 600,
        md: 1080,  
        lg: 1280, 
      },
    },
    palette: {
      primary: {
        main: '#00897b',
        light: '#80cbc4',
        dark: '#00695c',
        contrastText: '#fff',
      },
    },
  });
export default function Home() {
  const [isOpen, setIsOpen] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };



 
  const ref1 = useRef(null);
  const isInView1 = useInView(ref1, { once: true });
  const ref2 = useRef(null);
  const isInView2 = useInView(ref2, { once: true });
  const settings = {
    focusOnSelect: true,
    pauseOnHover: false,
    infinite: true,
    speed: 1100,
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: false,
    responsive: [
      {
        breakpoint: 700,  // Lorsque l'écran est inférieur à 700px
        settings: {
          slidesToShow: 1,  // Afficher 1 slide à la fois
          slidesToScroll: 1,  // Faire défiler 1 slide à la fois
        },
      },
    ],
  };


  return (
    <ThemeProvider theme={customTheme}>
    <div className="home" id="الرئيسية">
      <div className="homeTop">
        <div className="carouselPrsent">
          <div>
          <h2 className="descreption">مرحبا بكم في مركز سبأ منطقة الرجل</h2>
          <h3 className="sousDescreption2">سبأ منطقة الرجل – حيث تلتقي الفخامة بالعناية المتكاملة 
             نرتقي بتجربة العناية الرجالية إلى مستوى جديد من الفخامة والاحترافية، مستلهمين من أكثر من عشر سنوات من الخبرة والتميز لنقدم خدمات استثنائية تعكس أعلى معايير الجودة. في بيئة مصممة خصيصًا لراحتكم، نوفر لكم لحظات استرخاء فريدة تعزز من صحتكم الجسدية والنفسية، مع عناية متكاملة بالبشرة والجسم تمنحكم إطلالة متألقة وثقة لا مثيل لها.
</h3>
          <a href="whatsapp://send?phone=+966550769152">
                    <Button
                      startIcon={<WhatsAppIcon />}
                      sx={{ marginTop: "20px" }}
                      variant="contained"
                      color="primary"
                      size='large'
                    >
                   إحجز الآن
                    </Button>
                  </a>
        <div className="socialTop">
          <a
            href="https://www.instagram.com/spamanarea/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={insta2} alt="insta" className="socialIconTop" />
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571041986973"
            target="_blank"
            rel="noreferrer"
          >
            <img src={face2} alt="facebook" className="socialIconTop" />
          </a>
          <a
            href="https://www.tiktok.com/@spamanarea"
            target="_blank"
            rel="noreferrer"
          >
            <img src={tik2} alt="tik" className="socialIconTop" />
          </a>
          <a
            href="https://snapchat.com/t/flaOPhit"
            target="_blank"
            rel="noreferrer"
          >
            <img src={snap2} alt="snap" className="socialIconTop" />
          </a>
          <a
            href="whatsapp://send?phone=+966550769152"
            target="_blank"
            rel="noreferrer"
          >
            <img src={whats2} alt="whats" className="socialIconTop" />
          </a>
        </div>
        </div>
        </div>
      <div className="carouselHome">
            <div  className="slide-item">
              <img
                src={require(`../../Images/ban1.jpg`)}
                alt={`Slide ${ 1}`}
              />
              <div
                className="slideText"
                style={{
                  backgroundImage: `url(${require(`../../Images/ban1.jpg`)})`,
                }}
              >
                <div>
                <h3 className="sousDescreption">“سبأ منطقة الرجل” – حيث تلتقي الفخامة بالعناية المتكاملة
 نرتقي بتجربة العناية الرجالية إلى مستوى جديد من الفخامة والاحترافية، مستلهمين من أكثر من عشر سنوات من الخبرة والتميز لنقدم خدمات استثنائية تعكس أعلى معايير الجودة. في بيئة مصممة خصيصًا لراحتكم، نوفر لكم لحظات استرخاء فريدة تعزز من صحتكم الجسدية والنفسية، مع عناية متكاملة بالبشرة والجسم تمنحكم إطلالة متألقة وثقة لا مثيل لها.
</h3>
                <a href='/الخدمات'>
                    <Button
                      startIcon={<ReadMoreIcon />}
                      sx={{ marginTop: "20px",zIndex:99 }}
                      variant="contained"
                      color="primary"
                      size='large'
                    >
                    تصفح خدماتنا
                    </Button>
                  </a>
                </div>
              </div>
            </div>
      
      </div>
</div>
      <div className="presentation" id="الخدمات"
       ref={ref1}
        style={{
          transform: isInView1 ? "none" : "translateY(200px)",
          opacity: isInView1 ? 1 : 0,
          transition: `all 0.8s cubic-bezier(0.17, 0.55, 0.55, 1) 0.${6}s`,
        }}>
        <div>
       <h3> لأن راحتكم هي أولويتنا، نقدم لكم تجربة تفوق التوقعات – لأنكم تستحقون الأفضل</h3>
          <h1> الخدمات</h1>
       
        </div>
        <div className="present2">
          {icons.map((icon, index) => (
            <div key={index} className="iconContainer3">
              <div
                href={icon.name}
                target="_blank"
                rel="noreferrer"
                className="linkItems"
              >
                <img
                  src={require(`../../Images/programme/${icon.icon}.jpg`)}
                  alt={icon.name}
                  className="iconImg3"
                />
                <span>{icon.name}</span>
                <div>
                  <div className="price">
                    {icon.pricePromo ? (
                      <span
                        className="priceSpan"
                        style={{
                          textDecoration: "line-through",
                          color: "#151a5b",
                        }}
                      >
                        &nbsp;{icon.pricePromo} <span>ريال</span>
                      </span>
                    ) : (
                      <></>
                    )}
                    <span className="priceSpan">
                      {" "}
                      &nbsp;{icon.price} <span>ريال</span>{" "}
                    </span>
                  </div>
                  <a href={`/الخدمات/${icon.name}`}>
                    <Button
                      endIcon={<ArrowRightAltIcon />}
                      sx={{ marginTop: "20px" }}
                      variant="contained"
                      color="primary"
                      size="small"
                    >
                      أكثر تفاصيل
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          ))}

        </div>
      </div>
    
      <div className="presentation3" id="الموقع و أوقات العمل"
        ref={ref2}
        style={{
          transform: isInView2 ? "none" : "translateX(200px)",
          opacity: isInView2 ? 1 : 0,
          transition: `all 0.8s cubic-bezier(0.17, 0.55, 0.55, 1) 0.${6}s`,
        }}>
      
     
     
        <div
          className="present1"
        >
          <div>
            <h2>
              أوقات الدوام <AccessTimeIcon />
            </h2>
            <br />
            <h3>الأثنين:&nbsp;&nbsp;&nbsp;&nbsp; من ١١ صباح إلى ٤ فجر </h3>
            <h3>الثلاثاء:&nbsp;&nbsp;&nbsp;&nbsp;من ١١ صباح إلى ٤ فجر </h3>
            <h3>الأربعاء:&nbsp;&nbsp;&nbsp;&nbsp;من ١١ صباح إلى ٤ فجر </h3>
            <h3>الخميس:&nbsp;&nbsp;&nbsp; من ١١ صباح إلى ٤ فجر </h3>
            <h3>الجمعة:&nbsp;&nbsp;&nbsp;&nbsp; من ١ الظهر إلى ٤ فجر </h3>
            <h3>السبت:&nbsp;&nbsp;&nbsp; من ١١ صباح إلى ٤ فجر </h3>
            <h3>الأحد:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; من ١١ صباح إلى ٤ فجر </h3>
          </div>

          <div>
            <h2>
              الموقع  <LocationOnIcon />
            </h2>
            <br />
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3715.2662006680357!2d39.78884589999999!3d21.3794206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c21b003c14de01%3A0xe4808cb5197b0501!2z2LPYqNiiINmF2YbYt9mC2Kkg2KfZhNix2KzZhA!5e0!3m2!1sfr!2stn!4v1737305619214!5m2!1sfr!2stn"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
</div>

<div className="rateGroup">
<h1>اراء العملاء</h1>
  <Slider {...settings}>
    {rates.map((rate, index) => (
      <span className="rateblock" key={index}>
        
        <div className="rateDesign">
       <span>  <Rating readOnly name="size-small" defaultValue={rate.rating} size="medium" /></span>
        <span className="rateName"> <Avatar sx={{ bgcolor: deepOrange[500], width: 28, height: 28,fontSize:'16px' }}>{rate.name[0]}</Avatar>&nbsp; &nbsp;{rate.name}</span><br/>
        <span className="rateDescription">{rate.description}</span>
        </div>
      </span>
    ))}
  </Slider>
</div>


<Footer/>
   
    </div>
    </ThemeProvider>
  );
}
const rates = [
  {
    name: "RAID GHAZI",
    description: "ممتاز و تعامل راقی استقبال رائع و مهنية و خبرة عالية في المساج أحسنتم",
    rating: "10",
  },
  {
    name: "مخلد العتيبي",
    description: "ماشالله المحل ممتاز والحمام المغربي والمساج شغلهم ممتازه والسعر ولا في الأحلام صراحه انصح به وبقوه",
    rating: "10",
  },
  {
    name: "أحمد البردي",
    description: "شغل من الاخر يعطيكم العافية",
    rating: "10",
  },
  {
    name: "Naseer Salman",
    description: "المحل كويس خدماته جداً جميله العاملين فيه محترمين وشغلهم رهيب الله يعطيهم العافيه",
    rating: "10",
  },
  {
    name: "Talal Maashi",
    description: "شكرا على الشغل والترتيب يستاهل التقييم فعلا حمام مغربي عند بسام احترافي ونظيف والمركز مرتب ونظيف والمساج محترفين في شغلهم يستاهل تكرار الزيارة",
    rating: "10",
  },
  {
    name: "احمد عبده",
    description: "بصراحه جميل جدا التعامل معهم من يوم ما تدخل الين ما تطلع مهتمين فيك بكل التفاصيل انصح بالتعامل مع الاخ اسلام بالحلاقة وتنظيف البشره والمساج بصراحه متعه ينسيك تعبك",
    rating: "10",
  },
  {
    name: "mousa almaashi",
    description: "اخذت بكج عندهم والله منتازین و شغلهم على مستوى عالي و يستاهلو التجربه اكثر من مره الله يوفقكم",
    rating: "10",
  },
  {
    name: "صالح المالكي ص",
    description: "يعطيهم العافية بداية من خدمة العملاء والأسلوب الراقي في التعامل وثانيا الأجواء والإهتمام بالعميل وثالثا الخدمة المقدمة على أكمل وجه ولنا زيارة أخرى ان شاء الله",
    rating: "10",
  },
  {
    name: "يزن الحربي",
    description: "الصراحة جيتهم عن طريق اعلان السناب وكنت متخوف لاكن ماندمت ومو اخر زیاره",
    rating: "10",
  },
  {
    name: "Naseer Salman",
    description: "المحل كويس خدماته جداً جميله العاملين فيه محترمين وشغلهم رهيب الله يعطيهم العافيه",
    rating: "10",
  },
]
const icons = [
  {
    name: "جلسة المساج السويدي للاسترخاء",
    icon: "prog1",
    price: "89",
    pricePromo: "115",
    description: " تجربة تدليك بلطف باستخدام زيوت عطرية دافئة",
  },

  {
    name: "جلسة المساج التايلاندي لتنشيط الدورة الدموية",
    icon: "prog3",
    price: "99",
    pricePromo: "130",
    description:
      " تمديد الجسم بالكامل باستخدام تقنيات خاصة لتنشيط الدورة الدموية وزيادة مرونة العضلات ",
  },

  {
    name: "الحمام المغربي الملكي بالأعشاب",
    icon: "prog6",
    price: "100",
    pricePromo: "150",
    description:
      "حمام فاخر بالأعشاب الطبيعية، صابون بلدي مغربي، وصنفرة لتنشيط الدورة الدموية وتهدئة الجسم",
  },


  {
    name: "قناع مزدوج للبشرة لمظهر صحي",
    icon: "prog21",
    price: "20",
    description:
      "تطبيق قناعين للبشرة يشمل تنظيف عميق وترطيب مكثف للحصول على بشرة مشدودة ونضرة",
  },
];


